/**
 * The application's single React Query client.
 *
 * Lives outside App.tsx so that non-React code -- the API client's session
 * handling -- can reach it. When a session ends, everything cached for the
 * previous user (search hits, family details, invoices) must go with it:
 * on a shared office machine the next person to log in would otherwise see
 * the last person's results until the cache aged out.
 */

import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true, // Refresh data when user returns to tab
      refetchOnMount: true, // Refresh on component mount if data is stale
      retry: 1,
      // 2 minutes: window-focus/mount refetches dedupe against fresh cache,
      // avoiding refetch storms when alt-tabbing on query-heavy dashboards.
      // Hooks needing fresher data override staleTime per-query.
      staleTime: 2 * 60 * 1000,
      gcTime: 5 * 60 * 1000, // 5 minutes - garbage collect unused cache entries
    },
  },
});
